import {defineMessages} from 'react-intl';

export default defineMessages({
	color: {
		id: 'product.name.color',
		defaultMessage: ', {color}',
	},
});
